import { withRouter } from 'react-router-dom';
import ServicesNav from './ServicesNav';

export default withRouter(ServicesNav);
